module.exports = __webpack_public_path__ + "bf43222aad3d668834001dc4e26fc6b7.png";